enum FlightReportStatus{
    inProgress = "in-progress", 
    returned = "Returned", 
    signedOff = "Signed off", 
}

export default FlightReportStatus;